import { AnalyticsClient } from '@clockwise/clients/analytics';
import { AnnouncementsClient } from '@clockwise/clients/announcements';
import { ApprovalInstancesClient } from '@clockwise/clients/approval-instances';
import { ApprovalPoliciesClient } from '@clockwise/clients/approval-policies';
import { AuditClient } from '@clockwise/clients/audit';
import { ChartOfAccountsClient } from '@clockwise/clients/chart-of-accounts';
import { CompanyClient } from '@clockwise/clients/company';
import { CustomFieldsClient } from '@clockwise/clients/custom-fields';
import { CustomerActivitiesClient } from '@clockwise/clients/customer-activities';
import { CustomerBudgetsClient } from '@clockwise/clients/customer-budgets';
import { CustomerContactsClient } from '@clockwise/clients/customer-contacts';
import { CustomerExpensesClient } from '@clockwise/clients/customer-expenses';
import { CustomerTeamClient } from '@clockwise/clients/customer-team';
import { CustomerVariableExpenseOccurrencesClient } from '@clockwise/clients/customer-variable-expense-occurrences';
import { CustomersClient } from '@clockwise/clients/customers';
import { DashboardsClient } from '@clockwise/clients/dashboards';
import { DepartmentsClient } from '@clockwise/clients/departments';
import { ExpenseCatalogsClient } from '@clockwise/clients/expense-catalogs';
import { FeedbackClient } from '@clockwise/clients/feedback';
import { HolidaysClient } from '@clockwise/clients/holidays';
import { InvoiceSettingsClient } from '@clockwise/clients/invoice-settings';
import { InvoicesClient } from '@clockwise/clients/invoices';
import { NotificationsClient } from '@clockwise/clients/notifications';
import { ProductsClient } from '@clockwise/clients/products';
import { RatecardsClient } from '@clockwise/clients/ratecards';
import { ReleaseNotesClient } from '@clockwise/clients/release-notes';
import { ReportDefinitionsClient } from '@clockwise/clients/report-definitions';
import { ReportLabelsClient } from '@clockwise/clients/report-labels';
import { ReportsClient } from '@clockwise/clients/reports';
import { ServiceRolesClient } from '@clockwise/clients/service-roles';
import { SkillsClient } from '@clockwise/clients/skills';
import { SowsClient } from '@clockwise/clients/sows';
import { SystemRolesClient } from '@clockwise/clients/system-roles';
import { TenantsClient } from '@clockwise/clients/tenants';
import { TimersClient } from '@clockwise/clients/timers';
import { TimesheetApprovalsClient } from '@clockwise/clients/timesheet-approvals';
import { TimesheetSettingsClient } from '@clockwise/clients/timesheet-settings';
import { TimesheetUnlocksClient } from '@clockwise/clients/timesheet-unlocks';
import { TimesheetsClient } from '@clockwise/clients/timesheets';
import { UserEmployeeCostsClient } from '@clockwise/clients/user-employee-costs';
import { UsersClient } from '@clockwise/clients/users';
import { getOptionalEnv } from './env';

const baseUrl = getOptionalEnv('VITE_API_URL') ?? 'http://localhost:4801';

export const tenantsApi = new TenantsClient({ baseUrl });
export const announcementsApi = new AnnouncementsClient({ baseUrl });
export const companyApi = new CompanyClient({ baseUrl });
export const invoiceSettingsApi = new InvoiceSettingsClient({ baseUrl });
export const productsApi = new ProductsClient({ baseUrl });
export const ratecardsApi = new RatecardsClient({ baseUrl });
export const releaseNotesApi = new ReleaseNotesClient({ baseUrl });
export const reportsApi = new ReportsClient({ baseUrl });
export const reportDefinitionsApi = new ReportDefinitionsClient({ baseUrl });
export const reportLabelsApi = new ReportLabelsClient({ baseUrl });
export const dashboardsApi = new DashboardsClient({ baseUrl });
export const analyticsApi = new AnalyticsClient({ baseUrl });
export const customersApi = new CustomersClient({ baseUrl });
export const customFieldsApi = new CustomFieldsClient({ baseUrl });
export const chartOfAccountsApi = new ChartOfAccountsClient({ baseUrl });
export const departmentsApi = new DepartmentsClient({ baseUrl });
export const expenseCatalogsApi = new ExpenseCatalogsClient({ baseUrl });
export const feedbackApi = new FeedbackClient({ baseUrl });
export const holidaysApi = new HolidaysClient({ baseUrl });
export const invoicesApi = new InvoicesClient({ baseUrl });
export const customerTeamApi = new CustomerTeamClient({ baseUrl });
export const customerContactsApi = new CustomerContactsClient({ baseUrl });
export const customerBudgetsApi = new CustomerBudgetsClient({ baseUrl });
export const customerActivitiesApi = new CustomerActivitiesClient({ baseUrl });
export const customerExpensesApi = new CustomerExpensesClient({ baseUrl });
export const variableExpenseOccurrencesApi = new CustomerVariableExpenseOccurrencesClient({
  baseUrl,
});
export const sowsApi = new SowsClient({ baseUrl });
export const systemRolesApi = new SystemRolesClient({ baseUrl });
export const serviceRolesApi = new ServiceRolesClient({ baseUrl });
export const skillsApi = new SkillsClient({ baseUrl });
export const usersApi = new UsersClient({ baseUrl });
export const userEmployeeCostsApi = new UserEmployeeCostsClient({ baseUrl });
export const timesheetsApi = new TimesheetsClient({ baseUrl });
export const timesheetApprovalsApi = new TimesheetApprovalsClient({ baseUrl });
export const timesheetSettingsApi = new TimesheetSettingsClient({ baseUrl });
export const timesheetUnlocksApi = new TimesheetUnlocksClient({ baseUrl });
export const timersApi = new TimersClient({ baseUrl });
export const auditApi = new AuditClient({ baseUrl });
export const approvalPoliciesApi = new ApprovalPoliciesClient({ baseUrl });
export const approvalInstancesApi = new ApprovalInstancesClient({ baseUrl });
// Notification endpoints are reverse-proxied by the API (the notification
// service is not publicly exposed), so this targets the API base URL like
// every other client.
export const notificationsApi = new NotificationsClient({ baseUrl });
